import { Input } from '../../../../shared/components/FormControls';
import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { useEffect, useState } from 'react';

function SceneModal({
  visible,
  form,
  onChange,
  onCancel,
  onSave,
  mode = 'light',
}) {
  const isDark = mode === 'dark';
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const mediaQueryWidth = window.matchMedia('(max-width: 620px)');
    const handleMediaChange = () => {
      setIsPhone(mediaQueryWidth.matches);
    };
    handleMediaChange();
    mediaQueryWidth.addListener(handleMediaChange);
    return () => {
      mediaQueryWidth.removeListener(handleMediaChange);
    };
  }, []);

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onCancel}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4E7C5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : 350,
        height: isPhone ? 'calc(100% - 114px)' : 180,
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form ${isDark ? 'df_modal_form_dark' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div
          className='trialment_login_form_row'
          style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
        >
          Add Scene
        </div>
        <div className='trialment_login_form_row'>
          <Input
            type='text'
            placeholder='Name'
            value={form.name}
            onChange={(event) => onChange({ name: event.target.value })}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            marginTop: '15px',
            marginBottom: '8px',
          }}
        >
          <Button
            label='Cancel'
            type={mode === 'dark' ? 'onyx' : 'black-white'}
            onPress={onCancel}
          />
          <Button label='Save' type='cinnabar' onPress={onSave} />
        </div>
      </div>
    </Rodal>
  );
}

export default SceneModal;
